/**
*功能名称：数据库类型接口
*创 建 人：crq
*日    期：2023/07/25 10:15:17
*/
import { Methods } from '@newview/infrastructure';
import { DbCenterBaseApi } from "../DbCenterBaseApi";
export class ResourceFailoverApi extends DbCenterBaseApi {
    public get ControllerName(): any {
        return 'resourceFailover';
    }

    /**
     * 服务器迁移
     * @param params
     */
    public transferServer(params){
        return this.send(params,"transferServer",Methods.POST);
    }

    /**
     * 分页查询迁移记录
     * @param params (当前页：current, 页大小：size， records：条目，total:总数)
     */
    public getListPage(params){
        return this.send(params,"getEntitiesPage",Methods.GET);
    }

  /**
   * 查看迁移详情
   * @param id  (当前数据id)
  */
  public getFailoverInfo(id){
    return this.send({id},"getFailoverInfo",Methods.GET);
}
}